import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2PaginationModule } from "ng2-pagination";
import { Ng2DatetimePickerModule } from 'ng2-datetime-picker';
import { SharedModule } from "../shared/shared.module";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { CustomFormsModule } from "ng2-validation/dist";
import { FormHelperService } from "../core/services/form-helper.service";
import { Ng2AutoCompleteModule } from 'ng2-auto-complete';
import { AssetsService } from './asset.services';
import { AssetComponent } from './asset.component';
import { AssetFilterComponent } from './asset-filter.component';
import { AssetModalComponent } from './asset-modal.component';

@NgModule({
  imports: [CommonModule, SharedModule, FormsModule, Ng2PaginationModule, Ng2DatetimePickerModule, ReactiveFormsModule, CustomFormsModule, Ng2AutoCompleteModule],
  exports: [],
  declarations: [AssetComponent, AssetFilterComponent, AssetModalComponent],
  providers: [AssetsService, FormHelperService],
})
export class AssetModule { }



// WEBPACK FOOTER //
// ./src/app/assets/asset.module.ts